module.exports = __webpack_public_path__ + "static/bro6-fea19ba7e06b11322556a15192b25ccd.jpg";